/**

*/

/**
快捷操作
ver 1.0.0
@author liumingquan
修改记录：
  2018-9-25：
  规则：
  1.虚拟属性默认开头增加：_
*/

/**
  包装条目，赋值初始值。
*/
const warpItemObjectByDefault = function (object) {
  var itemTemplateObject = {
    visible: true,
  }
  return Object.assign(itemTemplateObject, object)
}

var shortcutOperateMixin = {
  methods: {
    /**
     * 添加输入组件，到动态表单中，并且重新渲染。
     * @param {array or object} items 输入组件列表

     */
    _addItemsAndReloadFormCreate(items) {
      if (!items) {
        // console.error("_addItemsAndReloadFormCreate, items is null.", items);
        return
      }

      if (Array.isArray(items)) {
        for (let item of items) {
          this.addItem(warpItemObjectByDefault(item))
        }
      } else {
        this.addItem(warpItemObjectByDefault(items))
      }

      this.reloadFormCreate()
    },

    /**
        快捷-添加分组和分组换行

      */
    shortcutOperateMixinAddGroupLabel() {
      var items = []
      var property = '_group_' + new Date().getTime()
      var name = '分组'
      const formData = {
        code: '_groupLabel' + property,
        property: '_groupLabel' + property,
        name: name,
        label: name,
        component: {
          code: 'groupLabel',
        },
        parameter: {
          id: 'groupLabel' + property,
        },
      }

      // formData = Object.assign(itemTemplateObject, formData);

      // console.log("shortcutOperateMixinAddGroupLabel", formData);

      items.push(formData)

      const formDataGourp = {
        code: '_groupBlank' + property,
        property: '_groupBlank' + property,
        name: '分组分隔符',
        component: {
          code: 'groupBlank',
        },
      }

      items.push(formDataGourp)

      this._addItemsAndReloadFormCreate(items)
    },

    /**
          快捷-添加虚线换行符
      */
    shortcutOperateMixinAddGroupDashed() {
      var property = '_groupDashed_' + new Date().getTime()
      var name = '虚线换行'
      var formData = {
        code: property,
        property: property,
        name: name,
        component: {
          code: 'groupDashed',
        },
      }

      this._addItemsAndReloadFormCreate(formData)
    },
    /**
             快捷-添加换行符
        */
    shortcutOperateMixinAddGroupDashedBlank() {
      var property = '_groupDashed_' + new Date().getTime()
      var name = '虚线换行'
      var formData = {
        code: property,
        property: property,
        name: name,
        component: {
          code: 'groupDashed',
        },
        parameter: {
          borderBottom: '0',
          bottomHeight: '0px',
        },
      }

      this._addItemsAndReloadFormCreate(formData)
    },

    /**
          快捷-添加竖线分割符
      */
    shortcutOperateMixinAddPartitionErect() {
      var property = '_partitionErect' + new Date().getTime()
      var name = '竖线分割符'
      var formData = {
        code: property,
        property: property,
        name: name,
        component: {
          code: 'partitionErect',
        },
        parameter: {
          erectHei: '68px',
          inline: true,
        },
      }

      this._addItemsAndReloadFormCreate(formData)
    },

    /**
        快捷-添加标签组（panguForm）
    */
    shortcutOperateMixinAddTagForPanguForm() {
      var property = 'formTag' + new Date().getTime()
      var name = '标签组'
      var formData = {
        code: property,
        property: property,
        name: name,
        label: name,
        component: {
          code: 'formTag',
        },
        parameter: {},
      }

      this._addItemsAndReloadFormCreate(formData)
    },
    /**
        快捷-添加分组（panguForm）
    */
    shortcutOperateMixinAddGroupForPanguForm() {
      var property = 'formGroup' + new Date().getTime()
      var name = '分组'
      var formData = {
        code: property,
        property: property,
        name: name,
        label: name,
        component: {
          code: 'formGroup',
        },
        parameter: {},
      }

      this._addItemsAndReloadFormCreate(formData)
    },
    /**
          快捷-添加虚线换行符
      */
    shortcutOperateMixinAddflashAddMedical() {
      var property = '_flashAddMedical_' + new Date().getTime()
      var name = '药械闪加'
      var formData = {
        code: property,
        property: property,
        name: name,
        component: {
          code: 'flashAddMedical',
        },
      }

      this._addItemsAndReloadFormCreate(formData)
    },
    /**
          快捷-添加分组符（mobile）
        */
    shortcutOperateMixinAddGroupSeparator() {
      var property = 'GROUP_SEPARATOR' + new Date().getTime()
      var name = '分组符'
      var formData = {
        code: property,
        property: property,
        name: name,
        component: {
          code: 'GROUP_SEPARATOR',
        },
      }

      this._addItemsAndReloadFormCreate(formData)
    },
    /**
          快捷-添加可点击视图组开始标识（mobile）
        */
    shortcutOperateMixinAddClickGroupStart() {
      var property = 'CLICK_GROUP_START' + new Date().getTime()
      var name = '可点击视图组开始标识'
      var formData = {
        code: property,
        property: property,
        name: name,
        component: {
          code: 'CLICK_GROUP_START',
        },
      }

      this._addItemsAndReloadFormCreate(formData)
    },
    /**
          快捷-添加可点击视图组结束标识（mobile）
        */
    shortcutOperateMixinAddClickGroupEnd() {
      var property = 'CLICK_GROUP_END' + new Date().getTime()
      var name = '可点击视图组结束标识'
      var formData = {
        code: property,
        property: property,
        name: name,
        component: {
          code: 'CLICK_GROUP_END',
        },
      }

      this._addItemsAndReloadFormCreate(formData)
    },
    /**
          快捷-添加横线图片（mobile）
        */
    shortcutOperateMixinAddLineImage() {
      var property = 'LINE_IMAGE' + new Date().getTime()
      var name = '横线图片'
      var formData = {
        code: property,
        property: property,
        name: name,
        component: {
          code: 'LINE_IMAGE',
        },
      }

      this._addItemsAndReloadFormCreate(formData)
    },
    /**
          快捷-添加换行符（mobile）
        */
    shortcutOperateMixinAddNextLine() {
      var property = 'NEXT_LINE' + new Date().getTime()
      var name = '换行符'
      var formData = {
        code: property,
        property: property,
        name: name,
        component: {
          code: 'NEXT_LINE',
        },
      }

      this._addItemsAndReloadFormCreate(formData)
    },
  }, // end methods
}

export { shortcutOperateMixin }
